import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import "../styles/Navbar.css";

function Navbar() {
  const [userRole, setUserRole] = useState(localStorage.getItem("role"));
  const [menuOpen, setMenuOpen] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleStorageChange = () =>
      setUserRole(localStorage.getItem("role"));
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("role");
    setUserRole(null);
    navigate("/");
    setMenuOpen(false);
  };

  return (
    <header className="navbar">
      {/* Logo */}
      <Link to="/" className="logo-link">
        <img src="/niveshly-logo.webp" alt="Niveshly Logo" className="logo" />
      </Link>

      {/* Hamburger (Mobile only) */}
      <div className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
        {menuOpen ? <FaTimes /> : <FaBars />}
      </div>

      {/* Menu */}
      <nav className={`menu ${menuOpen ? "active" : ""}`}>
        <Link to="/" onClick={() => setMenuOpen(false)}
          className={`nav-link ${location.pathname === "/" ? "active" : ""}`}>
          Home
        </Link>

        <Link to="/explore" onClick={() => setMenuOpen(false)}
          className={`nav-link ${location.pathname === "/explore" ? "active" : ""}`}>
          Explore Company
        </Link>

        <Link to="/FeaturesAndProcess" onClick={() => setMenuOpen(false)}
          className={`nav-link ${location.pathname === "/FeaturesAndProcess" ? "active" : ""}`}>
          Procedure
        </Link>

        {userRole === "admin" && (
          <>
            <Link to="/manage" onClick={() => setMenuOpen(false)} className="nav-link">
              Manage
            </Link>
            <Link to="/create_blog" onClick={() => setMenuOpen(false)} className="nav-link">
              Create-Article
            </Link>
          </>
        )}

        <Link to="/Blogs" onClick={() => setMenuOpen(false)} className="nav-link">
          Article
        </Link>

        <Link to="/videos" onClick={() => setMenuOpen(false)} className="nav-link">
          Video
        </Link>

        <Link to="/about" onClick={() => setMenuOpen(false)} className="nav-link">
          About Us
        </Link>

        <div className="nav-buttons">
          {userRole === "admin" ? (
            <button className="btn-outline" onClick={handleLogout}>
              Logout
            </button>
          ) : (
            <a
              href="https://www.whatsapp.com/channel/0029VbAzMGIJENxxcshB5D0h"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="btn-outline-login">WhatsApp</button>
            </a>
          )}
        </div>
      </nav>
    </header>
  );
}

export default Navbar;
